import { capitalizeWord } from 'src/utils/transformers';

export const roleToTitle = (role: string): string =>
  role.split('_').map(capitalizeWord).join(' ');

export const rolesToPayload = (roles: string[]): string[] =>
  roles.map(roleToTitle);

export const arrayIsEqual = (a: string[], b: string[]): boolean => {
  a.sort((x, y) => x.localeCompare(y));
  b.sort((x, y) => x.localeCompare(y));
  return a.length == b.length && a.every((el, i) => el === b[i]);
};
